import {
  AxiosResponse,
  AxiosInstance,
  AxiosError,
} from 'axios';
import { axiosInstance } from '../Requests';
import { Nationality } from '../../interfaces/Nationality';

export default class NationalityService {
  private axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = axiosInstance;
  }

  fetchNationalities(language: string): Promise<Array<Nationality>> {
    return this.axiosInstance.get(`utils/nationalities/${language.toUpperCase()}`)
      .then((response: AxiosResponse<Array<Nationality>>) => response.data)
      .catch((error: AxiosError) => {
        console.log('nationalities service error:'); // eslint-disable-line no-console
        console.error(error); // eslint-disable-line no-console
        return [];
      });
  }
}
